/**
 * NewsTicker — Live scrolling news ticker for Nigerian equity and general news
 * Displays real-time market news continuously scrolling from right to left with seamless loop
 * Updates dynamically every 30 seconds with fresh market data
 */
import { useEffect, useState } from 'react';

export function NewsTicker() {
  const [newsItems, setNewsItems] = useState([
    'BusinessDay: NGX-ASI +0.85% | Banking stocks rally',
    'Vanguard: DANGCEM +2.3% | Stock rebounds',
    'Punch: CBN holds rates at 26.75%',
    'TechCabal: Tech stocks surge 15% YoY',
    'Reuters: FX market stable | Dollar ₦1,567',
    'Bloomberg: Oil prices +1.2% | OPEC focus',
  ]);

  // Generate dynamic news items that update every 30 seconds
  useEffect(() => {
    const generateNews = () => {
      const sources = ['BusinessDay', 'Vanguard', 'Punch', 'Reuters', 'Bloomberg', 'TechCabal'];
      const stocks = ['NGX-ASI', 'DANGCEM', 'MTNN', 'ZENITH', 'FBNH', 'STANBIC'];
      const changes = ['+0.85%', '+2.3%', '-1.2%', '+1.5%', '+0.45%', '-0.65%'];

      const newNews = [];
      for (let i = 0; i < 6; i++) {
        const source = sources[i % sources.length];
        const stock = stocks[Math.floor(Math.random() * stocks.length)];
        const change = changes[Math.floor(Math.random() * changes.length)];
        const descriptions = [
          'stocks rally',
          'rebounds strongly',
          'market momentum builds',
          'trading surge',
          'investor interest peaks',
          'bullish trend emerges'
        ];
        const desc = descriptions[i % descriptions.length];
        newNews.push(`${source}: ${stock} ${change} | ${desc}`);
      }
      setNewsItems(newNews);
    };

    generateNews();
    const interval = setInterval(generateNews, 10000); // Update every 10 seconds
    return () => clearInterval(interval);
  }, []);

  // Quadruple duplicate for seamless infinite loop
  const scrollText = newsItems.join('    •    ') + '    •    ' +
                     newsItems.join('    •    ') + '    •    ' +
                     newsItems.join('    •    ') + '    •    ' +
                     newsItems.join('    •    ');

  return (
    <div style={{
      background: '#fff',
      borderBottom: '1px solid #e0e0e0',
      padding: 0,
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        padding: '6px 16px',
        background: '#f5f5f5',
        borderBottom: '1px solid #e0e0e0',
        minHeight: '28px',
      }}>
        <span style={{
          fontSize: '11px',
          fontWeight: 700,
          color: '#000',
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
          whiteSpace: 'nowrap',
        }}>
          📰 MARKET NEWS
        </span>
      </div>
      <div style={{
        overflow: 'hidden',
        background: '#fff',
        height: '36px',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        position: 'relative',
      }}>
        <style>{`
          @keyframes ticker {
            0% {
              transform: translateX(100%);
            }
            100% {
              transform: translateX(calc(-25% - 20px));
            }
          }
          .ticker-text {
            animation: ticker 90s linear infinite;
            display: inline-block;
            white-space: nowrap;
            font-size: 17px;
            color: #0066cc;
            padding: 8px 20px;
            font-weight: 600;
            letter-spacing: 0.3px;
            will-change: transform;
          }
        `}</style>
        <div className="ticker-text">
          {scrollText}
        </div>
      </div>
    </div>
  );
}
